import { useWindowManager } from "../../context/WindowContext";
import { WINDOW_BY_ID } from "../../data/windows";
import { useWindowPointer } from "../../hooks/useWindowPointer";
import shell from "./Window.module.css";

const RESIZE_EDGES = ["n", "s", "e", "w", "ne", "nw", "se", "sw"];

export const Window = ({ id, classes, menuItems, footer, children }) => {
  const {
    windows,
    isMobile,
    focus,
    minimize,
    close,
    toggleMaximize,
    move,
    resize,
    isFocused,
  } = useWindowManager();
  const win = windows[id];
  const meta = WINDOW_BY_ID[id];
  const { onTitlePointerDown, onResizePointerDown } = useWindowPointer({
    id,
    windowState: win,
    isMobile,
    move,
    resize,
    focus,
  });

  if (!win) {
    return null;
  }

  const focused = isFocused(id);
  const showResize = !isMobile && !win.isMaximized && win.status === "open";
  const titleClassNames = [
    classes.topPanel,
    focused ? null : shell.inactiveTitle,
    win.isMaximized ? null : shell.titleDrag,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={`${shell.frame}${
        win.status === "minimized" ? ` ${shell.frameMinimized}` : ""
      }`}
      style={{
        left: win.x,
        top: win.y,
        width: win.width,
        height: win.height,
        zIndex: win.zIndex,
      }}
      onPointerDown={() => focus(id)}
    >
      <div className={`${classes.notepad} ${shell.notepadFill}`}>
        <div
          className={titleClassNames}
          onPointerDown={onTitlePointerDown}
          onDoubleClick={() => toggleMaximize(id)}
        >
          <div className={classes.topPanelLeft}>
            <img src={meta.icon} alt={meta.windowIconAlt} draggable={false} />
            <p>{meta.title}</p>
          </div>
          <div className={classes.topPanelRight} data-window-control>
            <div
              onPointerDown={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.stopPropagation();
                minimize(id);
              }}
            >
              _
            </div>
            <div
              onPointerDown={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.stopPropagation();
                toggleMaximize(id);
              }}
            >
              ☐
            </div>
            <div
              onPointerDown={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.stopPropagation();
                close(id);
              }}
            >
              ✕
            </div>
          </div>
        </div>
        {menuItems ? (
          <div className={classes.linksPanel}>
            {menuItems.map((item) => (
              <p key={item.underline + item.rest}>
                <u>{item.underline}</u>
                {item.rest}
              </p>
            ))}
          </div>
        ) : null}
        <div className={classes.bottomPanel}>
          <div className={classes.mainPanel}>{children}</div>
        </div>
        {footer}
      </div>
      {showResize
        ? RESIZE_EDGES.map((edge) => (
            <div
              key={edge}
              className={`${shell.resize} ${shell[edge]}`}
              onPointerDown={(event) => onResizePointerDown(event, edge)}
            />
          ))
        : null}
    </div>
  );
};
